//firebase-messaging-sw.js
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
// import { getAnalytics } from 'firebase/analytics'
import requestPermission from './message/request_permission'

const firebaseConfig = {
  apiKey: 'AIzaSyC40BzHRDZwkrf15quK21LllMrHugDPVT4',
  authDomain: 'pushnotification-vue.firebaseapp.com',
  projectId: 'pushnotification-vue',
  storageBucket: 'pushnotification-vue.appspot.com',
  messagingSenderId: '365802389130',
  appId: '1:365802389130:web:5f4b7556739dd1655bb773',
  measurementId: 'G-Y1RT9CGZT2',
}

let messaging = null

try {
  const app = initializeApp(firebaseConfig)
  // const analytics = getAnalytics(app)
  messaging = getMessaging(app)
  
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload)
    // ...
  })

  getToken(messaging, {
    vapidKey:
      'BErLfp6Uyv6K_JO2hwKr7xuRhUBLZEQg10OUEHqTtSCk0Kfgb7muIgalWTV2AipINaXPgOSITEQWFEwl8p8_Xdk',
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log('[Firebase] Token obtido:', currentToken)

        localStorage.setItem('notification-token', currentToken)
        // Send the token to your server and update the UI if necessary
        // ...
      } else {
        // Show permission request UI
        console.log(
          '[Firebase] Sem token. Solicitando permissão para notificações.'
        )
        requestPermission()
        // ...
      }
    })
    .catch((err) => {
      console.log('[Firebase] Erro ao obter token de notificação:', err)
      // Silently fail - don't break the app if notifications don't work
    })

  console.log('[Firebase] Inicializado com sucesso')
} catch (error) {
  console.error('[Firebase] Erro na inicialização:', error)
  // Silently fail - don't break the app if Firebase doesn't initialize
}

export default messaging
